/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Conversation from './conversation';
import Conversations from './conversations';
import Animation006 from './animation006';
import Animation009 from './animation009';
import Animation015 from './animation015';
import Animation018 from './animation018';
import Animation019 from './animation019';
import Animation020 from './animation020';
import Animation021 from './animation021';
import Animation022 from './animation022';
import Animation023 from './animation023';
import Animation024 from './animation024';
import Animation025 from './animation025';
import Animation026 from './animation026';
import Animation027 from './animation027';
import Animation028 from './animation028';
import Animation029 from './animation029';
import Quiz from './../../components/quiz';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component006 from './component006';
import Component007 from './component007';
import Component008 from './component008';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Conversations,
  Animation006,
  Animation009,
  Animation015,
  Animation018,
  Animation019,
  Animation020,
  Animation021,
  Animation022,
  Animation023,
  Animation024,
  Animation025,
  Animation026,
  Animation027,
  Animation028,
  Animation029,
  Component001,
  Component002,
  Component003,
  Component004,
  Component006,
  Component007,
  Component008,
};

export default Components;
